import React, { useContext, useEffect, useState } from "react";
import classes from "../../pages/Dashboard.module.scss";
import { Row, Col } from "react-bootstrap";
import Clients from "./Clients";
import { ClientTypes, OrgIdContext, Domain } from "../../store/orgId_context";
import CurrentPackages from "./CurrentPackages";
import CurrentFinancialState from "./CurrentFinancialState";
import InvoicesGraph from "./InvoicesGraph";
import AppBox from "./AppBox";
import AppRecieveBox from "./AppRecieveBox";
import CompanySettingsNotification from "./CompanySettingsNotification";
import IntegrationNotification from "./IntegrationNotification";
import { UserUIStateContext } from "../../store/userUIStateContext";
import axios from "axios";
import SettingsBox from "./SettingsBox";
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import ButtonLink from "../UI/ButtonLink";
import { useTranslation } from 'react-i18next';
import SimplePanel from "./SimplePanel";
import { DDD, E2Data } from "../../lib/ddd/ddd";
import { set } from "react-hook-form";
import Todo from "./Todo";


const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const DashboardDisplay = ({ currentTData, clients, isLoading }) => {
  const {clientType, isTrustee, domain, isIntegrator, sessionInfo, mainOrgId, aboutOrgId, ISVCustomer, AccCustomer} = useContext(OrgIdContext);
  const {clientWizardStep, integrationData, serverDataLoaded, clientWizardFinished} = useContext(UserUIStateContext);
  const { t } = useTranslation();
  const [cl1, setCl1] = useState(0);
  const [cl1R, setClR1] = useState(0);
  const [cl2, setCl2] = useState(0);
  const [cl2R, setClR2] = useState(0);
  const [cl3, setCl3] = useState(0);
  const [cl3R, setClR3] = useState(0);
  const [isv1 , setIsv1] = useState(0);
  const [isv2 , setIsv2] = useState(0);
  const [isvR2, setIsvR2] = useState(0);
  const [isv3 , setIsv3] = useState(0);
  const [isvR3 , setIsvR3] = useState(0);
  useEffect(() => {
    
    /*axios.post("https://apisbx.fungpayments.com/v2/checkout/createCheckout", 
    {
      "amount": 1000,
      "currencyCode": "EUR",
      "accountId": "212100416ddcc007a1ebaadd0a8",
      "paymentProfileId" : "212100916de43007a272a0da012",
      "lineItems": [
        {
          "imageUrl": "https://strongpans.com/item/123.png",
          "name": "Titanium wok",
          "description": "Strongest pan known to humanity"
        }
      ]
    }, {
      auth: {
        username: "21210151076dd00730a83ccd019",
        password: "QC9llfbs2TVMgr9JuNLsRmEdudfJp5/AInK4ctuQb6nBr7aoOmUGatffiIuyIYe4JljssHx9wvDqPEAus4zi4I6xix+s5DMZp3Z2RikBlVHYh445VQidjVQscZMVbvgB2x0IuNyAlWGkEI4teODx+k19AyD4VaqdK5AjjnAw5yI7/GfHYrXpu4Jl+3+xCYm3wPauoOSjl/Au5gEsZvgIIcM+KH5TW03cq/b8IkuYZ6D7ck3QcgtCOzLMvT3AcFsVnLqtU0gTU8zJhX4Z+3NmFqZGLKnl7aCRqKQvbs05GaFY3KwK5WeaNcRwv904MJsO7pLQZETI2aPVQVngBWrRhg=="
      }
    });*/
    /*axios.post("https://apisbx.fungpayments.com/v2/legal-entity/onboardMerchantAccount", 
    {
      "parentAccountId": "212103e1076cb007309889f8015",
      "name": "Merchant Account Name",
      "description": "Additional description for Merchant",
      "onboardingEmail": "firstuser343432@email.com",
      "userLastName": "John",
      "userFirstName": "Doe",
      "createLegalEntity": true
  }, {
      auth: {
        username: "21210151076dd00730a83ccd019",
        password: "QC9llfbs2TVMgr9JuNLsRmEdudfJp5/AInK4ctuQb6nBr7aoOmUGatffiIuyIYe4JljssHx9wvDqPEAus4zi4I6xix+s5DMZp3Z2RikBlVHYh445VQidjVQscZMVbvgB2x0IuNyAlWGkEI4teODx+k19AyD4VaqdK5AjjnAw5yI7/GfHYrXpu4Jl+3+xCYm3wPauoOSjl/Au5gEsZvgIIcM+KH5TW03cq/b8IkuYZ6D7ck3QcgtCOzLMvT3AcFsVnLqtU0gTU8zJhX4Z+3NmFqZGLKnl7aCRqKQvbs05GaFY3KwK5WeaNcRwv904MJsO7pLQZETI2aPVQVngBWrRhg=="
      }
    });*/
    /*axios.post("https://apisbx.fungpayments.com/v2/account/createOperatingAccount", 
    {
      "parentResourceId": "21210021371510075488572a010",
      "name": "Submerchant 1",
      "description": "MCC 1234",
      "details": {
          "mcc": "5999",
          "city": "Amsterdam",
          "countryCode": "NL",
          "address": "Damrak 1",
          "websites": ["https://fungpayments.com", "https://fung.money"]
      }
    }, {
      auth: {
        username: "21210151076dd00730a83ccd019",
        password: "QC9llfbs2TVMgr9JuNLsRmEdudfJp5/AInK4ctuQb6nBr7aoOmUGatffiIuyIYe4JljssHx9wvDqPEAus4zi4I6xix+s5DMZp3Z2RikBlVHYh445VQidjVQscZMVbvgB2x0IuNyAlWGkEI4teODx+k19AyD4VaqdK5AjjnAw5yI7/GfHYrXpu4Jl+3+xCYm3wPauoOSjl/Au5gEsZvgIIcM+KH5TW03cq/b8IkuYZ6D7ck3QcgtCOzLMvT3AcFsVnLqtU0gTU8zJhX4Z+3NmFqZGLKnl7aCRqKQvbs05GaFY3KwK5WeaNcRwv904MJsO7pLQZETI2aPVQVngBWrRhg=="
      }
    });*/
    //axios.post("https://apisbx.fungpayments.com/v2/account/getAccountDetails/21210021371510075488572a010", 
    /*axios.post("https://apisbx.fungpayments.com/v2/account/createOperatingAccount", 
    {
    }, {
      auth: {
        username: "21210151076dd00730a83ccd019",
        password: "QC9llfbs2TVMgr9JuNLsRmEdudfJp5/AInK4ctuQb6nBr7aoOmUGatffiIuyIYe4JljssHx9wvDqPEAus4zi4I6xix+s5DMZp3Z2RikBlVHYh445VQidjVQscZMVbvgB2x0IuNyAlWGkEI4teODx+k19AyD4VaqdK5AjjnAw5yI7/GfHYrXpu4Jl+3+xCYm3wPauoOSjl/Au5gEsZvgIIcM+KH5TW03cq/b8IkuYZ6D7ck3QcgtCOzLMvT3AcFsVnLqtU0gTU8zJhX4Z+3NmFqZGLKnl7aCRqKQvbs05GaFY3KwK5WeaNcRwv904MJsO7pLQZETI2aPVQVngBWrRhg=="
      },
      headers : {
        'Access-Control-Allow-Origin' : '*'
      }
    });*/
    /*axios.post("https://apisbx.fungpayments.com/v2/payment-profile/createPaymentProfile", 
    {
      "accountResourceId": "212100416ddcc007a1ebaadd0a8",
      "name": "First time customer set-up22",
      "description": "Storing of credentials for future",
      "profileDetails": {
          "paymentMethods": [
              {
                  "transactionVariant": "card",
                  "active": true,
  
              }
          ],
          "cardConfiguration": {
            "threeds": {
                "triggerType": "STATIC"
            },
            "authorizationType": "FINAL_AUTH"
        }}}, {
      auth: {
        username: "21210151076dd00730a83ccd019",
        password: "QC9llfbs2TVMgr9JuNLsRmEdudfJp5/AInK4ctuQb6nBr7aoOmUGatffiIuyIYe4JljssHx9wvDqPEAus4zi4I6xix+s5DMZp3Z2RikBlVHYh445VQidjVQscZMVbvgB2x0IuNyAlWGkEI4teODx+k19AyD4VaqdK5AjjnAw5yI7/GfHYrXpu4Jl+3+xCYm3wPauoOSjl/Au5gEsZvgIIcM+KH5TW03cq/b8IkuYZ6D7ck3QcgtCOzLMvT3AcFsVnLqtU0gTU8zJhX4Z+3NmFqZGLKnl7aCRqKQvbs05GaFY3KwK5WeaNcRwv904MJsO7pLQZETI2aPVQVngBWrRhg=="
      }
    });*/
    
    /*const checkout = new Checkout({
      checkoutId: "{CHECKOUT_ID}",
      containerId: "paymentContainer",
      environment: "sandbox",
    })
    checkout.render();*/
    
  },[]);
  /*useEffect(() => {
    const checkout = new Checkout({
      checkoutId: "212102016e0ce007a740437a038",
      containerId: "paymentContainer",
      env: "sandbox",
    })
    checkout.on("checkout:loaded", (e) => {
      console.log(e);
  })
  
  checkout.on("checkout:completed", (e) => {
    console.log(e);
  })
  
  checkout.on("checkout:invalid", (e) => {
    console.log(e);
  })
  
  checkout.on("checkout:failed", (e) => {
    console.log(e);
  })
    checkout.render();
  }, []);*/
  const goToComission = () =>{
    window.location.href = "@signupei/suggest"
  }

  const onLogoutHandler = () => {
    axios
      .post(
        apiRequestAddress,
        { jsonrpc: "2.0", method: "Auth.SignOut", params: {}, id: 7 },
        {
          withCredentials: true,
        }
      )
      .then(() => {
        if(sessionInfo?.Extended?.Theme === "GVC") window.location = "https://www.globalvatcompliance.com/"
        else window.location = "@";
        sessionStorage.removeItem("mainOrgId");
      });
  };

  useEffect(() => {
    if(clientType===ClientTypes.ISV){
      const ddd = new DDD(apiRequestAddress);
      let args = {
          "IncludeCount" :true,
          "Skip" : 0,
          "Take" : 500,
          "Filter": null,
          "OrderBy": null
      };
      ddd.Rpc_ExecuteExtension("EUeInvoices.GetTCustomers", args).then((res) => {setIsv1(res?.result?.Count > 0 ? res?.result?.Count-1 : 0)});
      const now = new Date();
      const startOfYear = now.getFullYear();
      const startOfMonth = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}`;
      const soy1 = startOfYear+"01";
      const soy2 = startOfYear+"12";

      const e2Data = new E2Data("EU_TransformerCustomers_InvoicesSum").ApplyParams({skip:0, take:1, includeCount:true, filter:`CreatePeriod='${startOfMonth}' AND TransformerId='${mainOrgId}'`});
      e2Data.GetData().then((res) => {
        let row = res?.result?.data?.[0];
        console.log(row);
        if(row){
          setIsv2(row?.InvNumThisMonthIEI);
          setIsvR2(row?.InvNumThisMonthREI);
        }
      });
 
      const e2Data2 = new E2Data("EU_TransformerCustomers_InvoicesSum").ApplyParams({skip:0, take:100, includeCount:true, filter:`CreatePeriod>='${soy1}' AND CreatePeriod<='${soy2}' AND TransformerId='${mainOrgId}'`});
      //const e2Data2 = new E2Data("EU_TransformerCustomers_InvoicesSum").ApplyParams({skip:0, take:100, includeCount:true, filter:`CreatePeriod>='202301' AND CreatePeriod<='202312' AND TransformerId='51da1c7f-981b-48be-adfd-7f4bbb9a0689'`});
      e2Data2.GetData().then((res) => {
        let sum = 0;
        let sum2 = 0;
        res?.result?.data?.forEach((row) => {
          sum += row?.InvNumThisMonthIEI;
          sum2 += row?.InvNumThisMonthREI;
        });
        setIsv3(sum);
        setIsvR3(sum2);
      });
    }else if(clientType === ClientTypes.Company && !ISVCustomer){
      const startOfToday = new Date();
      startOfToday.setUTCHours(0, 0, 0, 0);
      const e2Data = new E2Data("EU_Invoices").ApplyParams({skip:0, take:0, includeCount:true, filter:`DateTimeCreate>'${startOfToday.toISOString()}' AND Mode='PROD'`});
      e2Data.GetData().then((res) => {setCl1(res?.result?.count)});
      const e2DataR = new E2Data("EU_Invoices_REI").ApplyParams({skip:0, take:0, includeCount:true, filter:`DateTimeCreate>'${startOfToday.toISOString()}' AND Mode='PROD'`});
      e2DataR.GetData().then((res) => {setClR1(res?.result?.count)});

      const startOfMonth = new Date(startOfToday);
      startOfMonth.setDate(1);
      const e2Data2 = new E2Data("EU_Invoices").ApplyParams({skip:0, take:0, includeCount:true, filter:`DateTimeCreate>'${startOfMonth.toISOString()}' AND Mode='PROD'`});
      e2Data2.GetData().then((res) => {setCl2(res?.result?.count)});
      const e2DataR2 = new E2Data("EU_Invoices_REI").ApplyParams({skip:0, take:0, includeCount:true, filter:`DateTimeCreate>'${startOfMonth.toISOString()}' AND Mode='PROD'`});
      e2DataR2.GetData().then((res) => {setClR2(res?.result?.count)});

      const startOfYear = new Date(startOfToday);
      startOfYear.setMonth(0);
      startOfYear.setDate(1);
      const e2Data3 = new E2Data("EU_Invoices").ApplyParams({skip:0, take:0, includeCount:true, filter:`DateTimeCreate>'${startOfYear.toISOString()}' AND Mode='PROD'`});
      e2Data3.GetData().then((res) => {setCl3(res?.result?.count)});
      const e2DataR3 = new E2Data("EU_Invoices_REI").ApplyParams({skip:0, take:0, includeCount:true, filter:`DateTimeCreate>'${startOfYear.toISOString()}' AND Mode='PROD'`});
      e2DataR3.GetData().then((res) => {setClR3(res?.result?.count)});
    }else{
      const startOfToday = new Date();
      startOfToday.setUTCHours(0, 0, 0, 0);
      const e2Data = new E2Data("EU_Invoices").ApplyParams({skip:0, take:0, includeCount:true, filter:`DateTimeCreate>'${startOfToday.toISOString()}' AND Mode='PROD'`});
      e2Data.GetData().then((res) => {setCl1(res?.result?.count)});
      const e2DataR = new E2Data("EU_Invoices_REI").ApplyParams({skip:0, take:0, includeCount:true, filter:`DateTimeCreate>'${startOfToday.toISOString()}' AND Mode='PROD'`});
      e2DataR.GetData().then((res) => {setClR1(res?.result?.count)});

      const startOfMonth = new Date(startOfToday);
      startOfMonth.setDate(1);
      const e2Data2 = new E2Data("EU_Invoices").ApplyParams({skip:0, take:0, includeCount:true, filter:`DateTimeCreate>'${startOfMonth.toISOString()}' AND Mode='PROD'`});
      e2Data2.GetData().then((res) => {setCl2(res?.result?.count)});
      const e2DataR2 = new E2Data("EU_Invoices_REI").ApplyParams({skip:0, take:0, includeCount:true, filter:`DateTimeCreate>'${startOfMonth.toISOString()}' AND Mode='PROD'`});
      e2DataR2.GetData().then((res) => {setClR2(res?.result?.count)});

      const startOfYear = new Date(startOfToday);
      startOfYear.setMonth(0);
      startOfYear.setDate(1);
      const e2Data3 = new E2Data("EU_Invoices").ApplyParams({skip:0, take:0, includeCount:true, filter:`DateTimeCreate>'${startOfYear.toISOString()}' AND Mode='PROD'`});
      e2Data3.GetData().then((res) => {setCl3(res?.result?.count)});
      const e2DataR3 = new E2Data("EU_Invoices_REI").ApplyParams({skip:0, take:0, includeCount:true, filter:`DateTimeCreate>'${startOfYear.toISOString()}' AND Mode='PROD'`});
      e2DataR3.GetData().then((res) => {setClR3(res?.result?.count)});
    }
  }, [clientType]);

  return (
    <div className={`w-100 p-5 ${classes.container}`}>
      {(clientType === ClientTypes.ISV || clientType === ClientTypes.AccService) && <>
        <Row className={classes["name-title"]}>{t("Welcome")} {sessionInfo?.User?.Name}!</Row>
        <Row className={classes["top-row"]}>
          <Col className="col-12 col-xl-6 mb-9 mb-xl-0" style={{maxWidth:"500px"}}>
            <Row className="pt-2">
              <Col className="col-12 col-xl-6 mb-6 mb-xl-0">
                <SimplePanel title={t("Transactions this month")}  tooltip={t("This number is recalculated once per day")} amount={isv2} amount2={isvR2} amount1Tooltip={t("Issued")} amount2Tooltip={t("Received")} slashTooltip={t("Total: ")+(isv2+isvR2)}/>
              </Col>
              <Col className="col-12 col-xl-6 mb-6 mb-xl-0">
                <SimplePanel title={t("Transactions this year")} amount={isv3} amount2={isvR3} colclass="mt-3" amount1Tooltip={t("Issued")} amount2Tooltip={t("Received")} slashTooltip={t("Total: ")+(isv3+isvR3)}/>
              </Col>
            </Row>
            <Row className="pt-2">
              <Col className="col-12 col-xl-6 mb-6 mb-xl-0">
                <SimplePanel title={t("Total customers")} amount={isv1} colclass="mt-3"/>
              </Col>
            </Row>
          </Col>
          <Col className="col-12 col-xl-6 mb-3 mb-xl-0 ms-auto">
            <InvoicesGraph/>
          </Col>
        </Row>
        <Row className={classes["bottom-row"]}>
          <Col className="col-12 col-xl-9 mb-3 mb-lg-0">
            <Clients
              totalInvoices={currentTData ? currentTData.NumTransformed : 0}
              clients={clients}
              mainOrgId={currentTData ? currentTData.TransformerID : null}
              isLoading={isLoading}
            />
          </Col>
          <Col className="col-12 col-xl-3">
            <Todo clients={clients}/>
          </Col>
        </Row>
      </>}
      {(clientType === ClientTypes.Company || clientType === ClientTypes.EndClient) && <>
        <Row className={classes["name-title"]}>{t("Welcome")} {sessionInfo?.User?.Name}!</Row>
        <Row className={classes["top-row"]}>
          <Col className="col-12 col-xl-4 mb-9 mb-xl-0" style={{maxWidth:"500px"}}>
            <Row className="pt-2">
              <Col className="col-12 col-xl-6 mb-6 mb-xl-0">
                <SimplePanel title={t("Total transactions today")} amount={cl1} amount2={cl1R} amount1Tooltip={t("Issued")} amount2Tooltip={t("Received")} slashTooltip={t("Total: ")+(cl1+cl1R)}/>
              </Col>
              <Col className="col-12 col-xl-6 mb-6 mb-xl-0">
                <SimplePanel title={t("Total transactions this month")} amount={cl2} amount2={cl2R} amount1Tooltip={t("Issued")} amount2Tooltip={t("Received")}  slashTooltip={t("Total: ")+(cl2+cl2R)}/>
              </Col>
            </Row>
            <Row className="pt-2">
              <Col className="col-12 col-xl-6 mb-6 mb-xl-0">
                <SimplePanel title={t("Total transactions this year")} amount={cl3} amount2={cl3R} amount1Tooltip={t("Issued")} amount2Tooltip={t("Received")} slashTooltip={t("Total: ")+(cl3+cl3R)}/>
              </Col>
            </Row>
          </Col>
          <Col className="col-12 col-xl-5 mb-3 mb-xl-0 ms-auto">
            <InvoicesGraph/>
          </Col>
          <Col className="col-12 col-xl-3 mb-3 mb-xl-0 ms-auto">
            <Todo clients={clients} max="500px"/>
          </Col>
        </Row>
        {AccCustomer &&
          <Row className={classes["bottom-row"]}>
            <Col className="col-12 col-lg-6">
              <AppBox/>
            </Col>
            <Col className="col-12 col-lg-6">
              <AppRecieveBox/>
            </Col>
          </Row>
        }
        {/* {!AccCustomer && 
        <Row className={classes["bottom-row"]}>
          <Col className="col-12 col-xl-9 mb-3 mb-lg-0"></Col>
          <Col className="col-12 col-xl-3">
            <Todo clients={clients}/>
          </Col>
        </Row>} */}
      </>}
      {/* <div id="paymentContainer"></div>
      {(clientType === ClientTypes.ISV || clientType === ClientTypes.AccService || isIntegrator) && <>
      {!integrationData?.integrationWizardCompleted && 
      <Row className={classes["top-row"]}>
        <Col className="col-12">
          <IntegrationNotification/>
        </Col>
      </Row>
      }
      </>}
      {clientType != null && <>
      {!clientWizardFinished && 
      <Row className={classes["top-row"]}>
        <Col className="col-12">
          <CompanySettingsNotification/>
        </Col>
      </Row>
      }
      </>}
      {isTrustee && domain===Domain.DDDInvoices && <>
      <Row className={classes["top-row"]}>
        <Col className="col-12 col-xl-3 mb-3 mb-xl-0">
          <CurrentFinancialState/>
        </Col>
        <Col className="col-12 col-xl-5 mb-3 mb-xl-0">
          <CurrentPackages/>
        </Col>
        <Col className="col-12 col-xl-4 mb-3 mb-xl-0">
          <InvoicesGraph/>
        </Col>
      </Row>
      </>}
      {isTrustee && domain===Domain.EInvoices && <>
        <Row className={classes["top-row"]}>
          <Col><CurrentFinancialState/></Col>
        </Row>
      </>}
      <Row className={classes["bottom-row"]}>
      {(clientType === null || (clientType !== null && !isTrustee) || clientType === ClientTypes.AccService) && <>
        {(domain === Domain.DDDInvoices || !isTrustee) && clientType !== ClientTypes.AccService && <>
        <Col className="col-12 col-lg-6">
          <AppBox/>
        </Col>
        <Col className="col-12 col-lg-6">
        <AppRecieveBox/>
        </Col></>}
        </>}
        {(domain === Domain.DDDInvoices && clientType === ClientTypes.AccService) && <>
          <Col className="col-12 col-lg-6">
          <AppBox/>
          </Col>
          <Col className="col-12 col-lg-6">
          <AppRecieveBox/>
          </Col>
        </>}
      {(isTrustee && domain===Domain.EInvoices) && <>
        <Col className="col-12 col-lg-4">
        <AppBox/>
        </Col>
        <Col className="col-12 col-lg-4">
        <AppRecieveBox/>
        </Col>
        <Col className="col-12 col-lg-4">
        <SettingsBox/>
        </Col>
        </>}
      {clientType === ClientTypes.ISV && domain === Domain.DDDInvoices && isTrustee && 
        <Col className="col-12 mb-3 mb-lg-0">
          <Clients
            totalInvoices={currentTData ? currentTData.NumTransformed : 0}
            clients={clients}
            mainOrgId={currentTData ? currentTData.TransformerID : null}
            isLoading={isLoading}
          />
        </Col>}
      </Row>
      {domain === Domain.EInvoices && <>
      <Row className="mt-5" style={{color:"#005683"}}>
        <Col className="text-center"><CardGiftcardIcon className={`me-2 ${classes["comission-icon"]}`}/><span className={classes["comission"]} onClick={goToComission}>{t("Like our service? Refer it and get 10% comission!")}</span></Col>
      </Row>
      <Row className="mt-2">
        <Col className="text-center">
        <ButtonLink className="px-4 py-1" onClick={onLogoutHandler}>
            {t("Sign out")}
          </ButtonLink>
        </Col>
      </Row>
      </>} */}
    </div>
  );
};

export default DashboardDisplay;
